import React from 'react'
import LBSymbols from '../assets/images/icons/LB-Symbols.svg?react'

type LBSymbolsIconProps = React.SVGProps<SVGSVGElement>

const LBSymbolsIcon = React.forwardRef<SVGSVGElement, LBSymbolsIconProps>(
  (props, ref) => <LBSymbols {...props} ref={ref} width='16' height='16' />
)

LBSymbolsIcon.displayName = 'LBSymbolsIcon'

export default LBSymbolsIcon
